module.exports = __webpack_public_path__ + "img/Skirt-Front-B1-Da-Gd-Ha-Ia.5872c12b.png";